import { HelpPanelTopicOptions } from '../../common/Constants';
import { Tour } from './GuidedTour';
import { PageTourMapping } from './GuidedTourDefinitions';


class GuidedTourStore {
    private toursPerPage: PageTourMapping;

    constructor(toursPerPage: PageTourMapping) {
        this.toursPerPage = toursPerPage;

        const names = this.getAllTourNames();
        
        if (names.length != new Set(names).size) {
            throw new Error('There are tours with duplicate names');
        }
    }

    getToursByPage(helpPanelTopic: HelpPanelTopicOptions): ReadonlyArray<Tour> {
        return this.toursPerPage[helpPanelTopic] || [];
    }

    getAllTours(): ReadonlySet<Tour> {
        const tours = Object.values(HelpPanelTopicOptions).map(page => this.getToursByPage(page));
        return new Set(tours.flat(1)); // because a tour can show up on multiple help panels.
    }

    getAllTourNames(): ReadonlyArray<string> {
        return Array.from(this.getAllTours()).map(tour => tour.name);
    }
}

export default GuidedTourStore;
